import React, { useContext, useEffect } from 'react';
import { StateContext } from 'context';
import './footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookSquare, faInstagram, faTwitterSquare } from '@fortawesome/free-brands-svg-icons';
import { Themes } from 'styles';
const Footer = (props) => {
    const state = useContext(StateContext);
    const indexTema = state && state.appReducer && state.appReducer.indexTema ? state.appReducer.indexTema : 0;
    useEffect(() => {
    }, [])

    return (
        <>
            <div id="footer" className="w3-block">
                <div className="w3-block" style={{backgroundColor: Themes[indexTema].D3}}>
                    <div className="w3-content" style={{ paddingTop: '40px', paddingBottom: '40px' }}>
                        <div className="w3-row">
                            <div className="w3-col l8 bs-bbox col-copyright" style={{ paddingLeft: '16px', paddingBottom: '16px' }}>
                                <span>©2022 Serfin SA. Todos los derechos reservados | Diseñado por <span className="font-lato-black">Serfin SA</span></span>
                            </div>
                            <div className="w3-col l4 bs-bbox col-social-links">
                                <a href="https://www.facebook.com/Serfin-SA-208620082518478" target="_blank" rel="noreferrer" aria-label="Facebook"><FontAwesomeIcon icon={faFacebookSquare} color="#fff" size="2x" aria-hidden="true" title="facebook"></FontAwesomeIcon></a>
                                <a href="https://www.instagram.com/serfin_sa/" target="_blank" rel="noreferrer" aria-label="Instagram"><FontAwesomeIcon icon={faInstagram} color="#fff" size="2x" aria-hidden="true" title="instagram"></FontAwesomeIcon></a>
                                {/* <a href="https://twitter.com/serfinpy" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faTwitterSquare} color="#fff" size="2x" aria-hidden="true" title="twitter"></FontAwesomeIcon></a> */}
                                {/* <a href="https://wa.me/595981294071"><FontAwesomeIcon icon={faWhatsapp} color="#fff" size="2x" aria-hidden="true" title="whatsapp"></FontAwesomeIcon></a> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default Footer;